import { ApolloError, useQuery } from '@apollo/client'
import { GET_VEHICLE_TEMPLATES_AUTOCOMPLETE } from 'features/VehicleTemplates/queries'
import { VehicleTemplateSuggestion } from 'gql/generated/graphql'

interface IUseVehicleTemplateAutocompleteOptions {
  skip?: boolean
}

interface IUseVehicleTemplateAutocompleteResponse {
  vehicleTemplate: VehicleTemplateSuggestion | null
  loading: boolean
  error?: ApolloError
}

export const useVehicleTemplateAutocomplete = (
  vehicleTemplateId: string,
  { skip }: IUseVehicleTemplateAutocompleteOptions = {}
): IUseVehicleTemplateAutocompleteResponse => {
  const { data, loading, error } = useQuery(GET_VEHICLE_TEMPLATES_AUTOCOMPLETE, {
    variables: {
      input: {
        id: vehicleTemplateId
      }
    },
    skip
  })

  return {
    vehicleTemplate: data?.vehicleTemplateSuggestions?.items.at(0) || null,
    loading,
    error
  }
}
